import { ErrorEffects } from './error.effects';
export const effects: any[] = [ErrorEffects];
